import React, { useEffect, useState } from 'react';
import moment from 'moment';
import classes from '../pipeline.module.scss';
import Button from '../../../../_common/Form/Buttons/Button';
import { RangeDatePicker } from '../../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import { useQuery } from '../../../../../utils/hooks/useQuery';
import Utils from '../../../../../utils/utils';
import Pivots from '../PipelineReports/Sections/Pivots10/Pivots';
import Loader from '../../../../_common/Loader/Loader';

const collectRequestData = (requestData) => {
  const data = Utils.deleteEmptyKeys(requestData);

  if (data.start) {
    if (!data.end) {
      data.end = moment(data.start).add(1, 'day').format('YYYY-MM-DD');
    } else {
      data.end = moment(data.end).format('YYYY-MM-DD');
    }
  }

  return data;
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');

const PipelineCRM = () => {
  const { query, setQuery } = useQuery();

  const [filters, setFilterData] = useState({
    start: query.start || thisMonthStartDay,
    end: query.start && !query.end ? '' : query.end || thisMonthEndDate,
  });

  const [params, setParams] = useState(null);

  const changeRequestData = (path, value) => {
    setFilterData((prev) => {
      const newFilters = { ...prev };

      if (path === 'date') {
        const [start, end] = value;

        newFilters.start = start;
        newFilters.end = end;
      } else {
        newFilters[path] = value;
      }

      return newFilters;
    });
  };

  const update = (requestData = filters) => {
    setQuery(Utils.deleteEmptyKeys(requestData));
    setParams(collectRequestData(requestData));
  };

  const clearFilters = () => {
    const sendingData = {
      start: thisMonthStartDay,
      end: thisMonthEndDate,
    };

    setFilterData(sendingData);
    update(sendingData);
  };

  useEffect(() => {
    update();
  }, []);

  return (
    <div className={classes.wrapper}>
      <div className={classes.filters_wrapper}>
        <RangeDatePicker
          currentDate={filters}
          onChangeDate={(date) => changeRequestData('date', date)}
          showLastYear
        />

        <div className={classes.btns_wrapper}>
          <Button
            title="Update"
            onClick={() => update()}
          />

          <Button
            title="Clear"
            clearButton
            onClick={clearFilters}
          />
        </div>
      </div>

      {!params
        ? (
          <div className={classes.loader_wrapper}>
            <Loader />
          </div>
        )
        : (
          <div className={classes.report_wrapper}>
            <Pivots params={params} />
          </div>
        )}
    </div>
  );
};

export default PipelineCRM;
